import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultComponent } from './default.component';
import { AppSettingsComponent } from '../../modules/app-settings/app-settings.component';
import { DashboardComponent } from 'src/app/modules/dashboard/dashboard.component';
import { RouterModule } from '@angular/router';
import { ClassComponent } from 'src/app/modules/class/class.component';
import { StudentComponent } from 'src/app/modules/student/student.component';
import { QuestionBankComponent } from 'src/app/modules/question-bank/question-bank.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DashboardService } from 'src/app/modules/dashboard.service';
import { ClassService } from 'src/app/providers/class/class.service';
import { ExamService } from 'src/app/providers/exam/exam.service';
import { StudentService } from 'src/app/providers/student/student.service';
import { QuestionService } from 'src/app/providers/question/question.service';
import { ExamComponent } from '../../modules/exam/exam.component';

@NgModule({
  declarations: [
    DefaultComponent,
    DashboardComponent,
    ClassComponent,
    ExamComponent,
    StudentComponent,
    QuestionBankComponent,
    AppSettingsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    MatSidenavModule,
    MatDividerModule,
    FlexLayoutModule,
    MatCardModule,
    MatIconModule,
    MatPaginatorModule,
    MatTableModule,
    MatSelectModule,
    MatCheckboxModule
  ],
  providers: [
    DashboardService,
    ClassService,
    ExamService,
    StudentService,
    QuestionService
  ]
})
export class DefaultModule { }
